// Gmail IDs are scoped to inbox/owner/unit; equal subjects alone never merge.
export function quoteThreads(quotes) {
    const groups = new Map();
    for (const quote of quotes) {
        const key = quote.threadId && quote.mailbox ? JSON.stringify([quote.owner, quote.mailbox, quote.businessUnit || 'coffee_vending', quote.threadId]) : `quote:${quote._id}`;
        if (!groups.has(key)) groups.set(key, { key, messages: [] });
        groups.get(key).messages.push(quote);
    }
    return [...groups.values()].map(group => {
        group.messages.sort((a, b) => new Date(b.receivedAt || b.createdAt) - new Date(a.receivedAt || a.createdAt));
        return { ...group, latest: group.messages[0], latestExtracted: group.messages.find(q => q.extracted || q.reviewed) };
    }).sort((a,b) => new Date(b.latest.receivedAt || b.latest.createdAt) - new Date(a.latest.receivedAt || a.latest.createdAt));
}
